"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useIsomorphicLayoutEffect = void 0;

var _react = require("react");

// suppress the useLayoutEffect warning on server side.
var useIsomorphicLayoutEffect = typeof window !== 'undefined' ? _react.useLayoutEffect : _react.useEffect;
exports.useIsomorphicLayoutEffect = useIsomorphicLayoutEffect;


//////////////////
// WEBPACK FOOTER
// ./~/react-dnd/dist/cjs/hooks/internal/useIsomorphicLayoutEffect.js
// module id = 131
// module chunks = 0